import { useGetPreviousAnswers } from "@/core/hooks/useGetPreviousAnswers/useGetPreviousAnswers";
import { FieldProps } from "@/core/components/Field";
import FlightPathBanner from "../../partials/FlightPathBanner";
import { Card } from "@mui/material";

const FlightCard = ({ field }: FieldProps) => {
  const {
    properties: { requiredInputVariables },
  } = field;

  if (!requiredInputVariables) {
    throw new Error("Missing required input variable names.");
  }

  const { result } = useGetPreviousAnswers(requiredInputVariables);

  const {
    originIATA: originAirportData,
    destinationIATA: destinationAirportData,
  } = result;

  return (
    <Card sx={{ boxShadow: "none", padding: 2 }}>
      <FlightPathBanner
        originAirportData={originAirportData}
        destinationAirportData={destinationAirportData}
        hasArrow={false}
      />
    </Card>
  );
};

export default FlightCard;
